module.exports = __webpack_public_path__ + "img/symbol_2.2b3c723d.png";